import type {
  QuickFillPropertyPanelState,
  QuickFillSidePanelsProps,
  QuickFillValuePanelState,
} from '../ui/components';

export interface BuildQuickFillSidePanelsPropsInputs {
  useDrawerPanels: boolean;
  valuePanel: QuickFillValuePanelState;
  propertyPanel: QuickFillPropertyPanelState;
}

/**
 * Pure builder for the QuickFillSidePanels props.
 *
 * Assembles the drawer layout flag and the value/property panel state
 * objects into the shape expected by QuickFillSidePanels.
 */
export function buildQuickFillSidePanelsProps(
  inputs: BuildQuickFillSidePanelsPropsInputs
): QuickFillSidePanelsProps {
  const { useDrawerPanels, valuePanel, propertyPanel } = inputs;

  return {
    useDrawerPanels,
    valuePanel,
    propertyPanel,
  };
}
